import { styled } from '@mui/material/styles';

import './layout.css';

const StyledFooter = styled('footer')(({ theme }) => ({
  position: 'static',
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '0 5px 5px',
  color: theme.palette.bitpix.main,
  '& a': {
    color: theme.palette.bitpix.main,
  },
  [theme.breakpoints.down('sm')]: {
    width: '80%',
    marginTop: 50,
  },
}));

export default function Footer() {
  return (
    <StyledFooter>
      &copy;&nbsp;
      <a href="http://www.icuantix.com" target="_blank" rel="noopener noreferrer">
        8bitpix
      </a>
      &nbsp;- Sergio Bruni &copy; 2020 &nbsp;|&nbsp; All rights reserved
    </StyledFooter>
  );
}
